module.exports = "/assets/data/64271d28cb0380ebe8edf465691df9ab-B20.data.json";